<template>
  <div class="elements-controls">
    <div class="nav">
      <div class="nav-items mr-1">
        <Button
          class="elements-toggle mr-2"
          :class="{ selected: elementGroup === 'promo' }"
          :disabled="disabled || elementGroup === 'promo'"
          @click="$emit('elements-toggle', 'promo')"
        >
          <v-icon slot="icon-start" name="images" scale=".9" class="mr-1" />
          Image Library
        </Button>

        <Button
          class="elements-toggle"
          :class="{ selected: elementGroup === 'custom' }"
          :disabled="disabled || elementGroup === 'custom'"
          @click="$emit('elements-toggle', 'custom')"
        >
          <v-icon
            slot="icon-start"
            name="cloud-upload-alt"
            scale=".9"
            class="mr-1"
          />
          My Uploads
        </Button>
      </div>
      <!-- .mr-auto -->

      <div class="nav-items">
        <Button
          class="primary xxs relative"
          :disabled="disabled"
          @click="$emit('upload-click')"
        >
          Upload
        </Button>

        <Button
          class="danger xxs ml-1"
          :disabled="disabled"
          @click="$emit('close-click')"
        >
          Close
        </Button>
      </div>
    </div>
    <!-- .nav -->

    <div class="divider-dashed" />

    <!-- Elements List Nav -->
    <slot name="element-list-nav" />
  </div>
  <!-- .flex -->
</template>

<script>
export default {
  name: "ElementsListControls",

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    elementGroup: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.elements-controls {
}

.nav {
  @apply flex flex-wrap items-center justify-between;
}

.nav-items {
  @apply flex items-center mb-2;

  @screen sm {
    @apply mb-0;
  }

  @screen md {
    @apply mb-1;
  }

  @screen lg {
    @apply mb-0;
  }
}

.elements-toggle {
  @apply p-0 no-underline text-xs relative text-grey font-sans font-semibold;

  &.selected {
    @apply text-brand opacity-100;
  }

  &:disabled {
    @apply bg-transparent;
  }

  &:hover {
    &:disabled {
      @apply bg-transparent;
    }
  }
}

.elements-upload-tag {
  @apply font-sans font-normal text-brand absolute block bg-success text-white;
  border-radius: 5px;
  font-size: 9px;
  padding: 1px 3px;
  right: -21px;
  top: -13px;
  transform: rotate(5deg);
}

.upload-arrow {
  @apply block absolute;
  right: -16px;
  top: 3px;
  transform: rotate(13deg);
  width: 13px;
}

.divider-dashed {
  @apply w-full mx-0;
  border-width: 0 0 2px;
  height: 2px;
  margin-top: 13px;
}

.lock-icon {
  @apply ml-1;
  transform: rotate(3deg);
}
</style>
